import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import BackToTop from '../components/backToTop/BackToTop';
import './payment.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleCheck, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { faCircleExclamation } from '@fortawesome/pro-light-svg-icons';
import { GetBanks } from '../functions/Banks';
import InstalmentPlanStatement from '../components/payment/InstalmentPlanStatement';
import CreditDebtGuarantee from '../components/payment/CreditDebtGuarantee';
import classNames from 'classnames';
/*import TagManager from 'react-gtm-module';*/
import { tracking } from '../functions/Tracking';
import { Action } from '../enums/TrackingActionType';
import { getErrorLogIdFromResponse } from '../functions/ErrorLogging';
import { addInterestToPrice } from '../functions/Renewal';

//const tagManagerArgs = {
//    dataLayer: {
//        userId: '001',
//        userProject: 'CAQWeb',
//        page: 'payment'
//    },
//    dataLayerName: 'PaymentPageDataLayer'
//}

export default function RenewalPayment(props: any) {
    const location = useLocation();
    const [renewal, setRenewal] = useState<any>(JSON.parse(localStorage.getItem('renewal') || ""));
    const [customerDetails, setCustomerDetails] = useState<CustomerDetails>(JSON.parse(localStorage.getItem('customerDetails') || ""));
    const [accountHolder, setAccountHolder] = useState<string>("");
    const [accountNumber, setAccountNumber] = useState<any>("");
    const [bankName, setBankName] = useState<string>("");
    const [sortCode, setSortCode] = useState<string>("");
    const [accountHolderValid, setAccountHolderValid] = useState<boolean>(true);
    const [accountNumberValid, setAccountNumberValid] = useState<boolean>(true);
    const [bankNameValid, setBankNameValid] = useState<boolean>(true);
    const [sortCodeValid, setSortCodeValid] = useState<boolean>(true);
    const [autoRenew, setAutoRenew] = useState<boolean>(true);
    const [displayHowItWorks, setDisplayHowItWorks] = useState<boolean>(false);
    const [banks, setBanks] = useState<any[]>([]);
    let pdetails = {
        accountHolder: "",
        sortCode: "",
        accountNumber: "",
        bankName: ""
    };
    const [paymentDetails, setPaymentDetails] = useState<PaymentDetails>(pdetails);
    const [paymentFailed, setPaymentFailed] = useState<boolean>(false);
    const navigate = useNavigate();
    const pageNo: number = 6;
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
    const config = JSON.parse(localStorage.getItem('siteConfig') || "{}");

    const userData = localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData') as string) : null;

    /*TagManager.dataLayer(tagManagerArgs)*/

    var accountHolderClasses = classNames(
        {
            'validation-fail': !accountHolderValid
        }
    );

    var accountNumberClasses = classNames(
        {
            'validation-fail': !accountNumberValid
        }
    );

    var bankNameClasses = classNames(
        {
            'validation-fail': !bankNameValid
        }
    );

    var sortCodeClasses = classNames(
        {
            'validation-fail': !sortCodeValid
        }
    );

    useEffect(() => {
        props.setCurrentPage(pageNo);
        props.setSidebarVisibility(false);
        setCustomerDetails(JSON.parse(localStorage.getItem('customerDetails') || ""));
        setRenewal(JSON.parse(localStorage.getItem('renewal') || ""));
        GetBanks(apiBaseUrl).then(data => {
            setBanks(data);
        });


        fetch(`${apiBaseUrl}customer/SetPremiumForDeviceDetection?deviceDetectionID=${localStorage.getItem('deviceDetectionID')}&premium=${renewal.premium}`, {
        })
            .then(response => {
                return response.json();
            })
            .catch((error) => {

            });

    }, [])


    function backNavigation() {
        navigate("/YourRenewal");
    }

    const updateAccountHolder = (e: React.ChangeEvent<HTMLInputElement>) => {
        setAccountHolder(e.target.value);
        let updatedPaymentDetails = paymentDetails;
        updatedPaymentDetails.accountHolder = e.target.value;
        setPaymentDetails(updatedPaymentDetails);
    };

    const updateBank = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setBankName(e.target.value);
        let updatedPaymentDetails = paymentDetails;
        updatedPaymentDetails.bankName = e.target.value;
        setPaymentDetails(updatedPaymentDetails);
    };

    const updateAccountNumber = (e: React.ChangeEvent<HTMLInputElement>) => {
        // remove all non numeric characters
        let newAccountNumber = e.target.value.replace(/\D/g, '');
        setAccountNumber(newAccountNumber);
        let updatedPaymentDetails = paymentDetails;
        updatedPaymentDetails.accountNumber = e.target.value;
        setPaymentDetails(updatedPaymentDetails);
    };

    const updateSortCode = (e: React.ChangeEvent<HTMLInputElement>) => {
        let typedSortCode = e.target.value;
        typedSortCode = sortCodeDashFix(typedSortCode);
        setSortCode(typedSortCode);
        let updatedPaymentDetails = paymentDetails;
        updatedPaymentDetails.sortCode = e.target.value;
        setPaymentDetails(updatedPaymentDetails);
    };

    const sortCodeDashFix = (sortCodeToFix: string) => {
        let fixedSortCode = sortCodeToFix.replace("-", "").replace("-", "").replace(/\D/g, '');
        if (fixedSortCode.length > 4) {
            fixedSortCode = fixedSortCode.slice(0, 2) + "-" + fixedSortCode.slice(2, 4) + "-" + fixedSortCode.slice(4);
        } else {
            if (fixedSortCode.length > 2) {
                fixedSortCode = fixedSortCode.slice(0, 2) + "-" + fixedSortCode.slice(2, 4);
            }
        }

        return fixedSortCode;
    }

    const validatePaymentDetails = () => {
        let formValid = false;
        let validAccountHolder = validateAccountHolder();
        let validAccountNumber = validateAccountNumber();
        let validSortCode = validateSortCode();
        let validBankName = validateBankName();
        if (validAccountHolder && validAccountNumber && validSortCode && validBankName) {
            formValid = true;
        }

        if (formValid) {
            purchase();
        }
    }

    const validateAccountHolder = () => {
        let valid = true;
        if (accountHolder === "" || accountHolder === null || accountHolder === undefined) {
            valid = false;
        }

        setAccountHolderValid(valid);
        return valid;
    }

    const validateAccountNumber = () => {
        let valid = true;
        if (accountNumber.length !== 8) {
            valid = false;
        }

        setAccountNumberValid(valid);
        return valid;
    }

    const validateBankName = () => {
        let valid = true;
        if (bankName === "" || bankName === null || bankName === undefined) {
            valid = false;
        }

        setBankNameValid(valid);
        return valid;
    }

    const validateSortCode = () => {
        let valid = true;
        if (/^(?!(?:0{6}|00-00-00))(\d{6}|(\d{2}-){2}\d{2})$/.test(sortCode) === false) {
            valid = false;
        }
        setSortCodeValid(valid);
        return valid;
    }

    const toggleAutoRenew = () => {
        setAutoRenew(!autoRenew);
    }

    const toggleHowItWorksDisplay = () => {
        setDisplayHowItWorks(!displayHowItWorks);
    }

    const confirmPay = () => {
        validatePaymentDetails();
    }

    // Begin Purchase 
    const purchase = async () => {
        fetch(`${apiBaseUrl}admin/PurchaseRenewal`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json, text/plain',
                'Content-Type': 'application/json;charset=UTF-8'
            },
            body: JSON.stringify({
                policyNumber: renewal.policyNumber,
                policyHistoryId: renewal.historyId.toString(),
                annual: false,
                "bankDetails": {
                    "accountNo": accountNumber,
                    "holder": accountHolder,
                    "bankName": bankName,
                    "sortCode": sortCode,
                    "sortCode1": "",
                    "sortCode2": "",
                    "sortCode3": ""
                },
                token: userData.token
            })
        })
            .then(response => {
                return response.json();
            }).then(data => {
                localStorage.setItem("policyRef", renewal.policyNumber);
                navigate('/Completed'); // Navigate to completed page
            })
            .catch((error) => {
            });
    }

    return (
        <>
            <div className="pay-container">
                {paymentFailed &&
                    <div className="payment-failed">Payment failed</div>}
                <p className="pay-title">Review your cover</p>
                <p className="pay-return" onClick={() => backNavigation()}>Return to my renewal</p>
                <p>Thank you for using {config.tradingName} to choose your Insurance policy.</p>
                <p>Please review your details and add your payment details to confirm the purchase.</p>

                <div className="payment-summary-details">
                    <p className="payment-header">Summary details</p>
                    <p><FontAwesomeIcon className="tick-icon" icon={faCircleCheck} />{renewal.schemeName}</p>
                    <div className="added-cover-payment">
                        {renewal.breakdown.cover.map((cover: any, index: any) => {
                            return (
                                <p>
                                    <FontAwesomeIcon className="tick-icon" icon={faCircleCheck} />
                                    {cover.coverText} - {cover.coverValue}
                                </p>
                            )
                        }
                        )}
                    </div>
                </div>

                <div>
                    <p className="payment-header">Set up your Direct debit</p>
                    <p>We'll take the following payments:</p>
                    <p><FontAwesomeIcon className="tick-icon" icon={faCircleCheck} />First installment &pound;{addInterestToPrice(renewal.paymentPlans[0].instalments[0].capital, renewal.paymentPlans[0].instalments[0].interest)}</p>
                    <p><FontAwesomeIcon className="tick-icon" icon={faCircleCheck} />Followed by {renewal.paymentPlans[0].noInstalments - 1} monthly instalments of &pound;{addInterestToPrice(renewal.paymentPlans[0].instalments[1].capital, renewal.paymentPlans[0].instalments[1].interest)}</p>
                    <p><FontAwesomeIcon className="tick-icon" icon={faCircleCheck} />Charge for credit ({renewal.paymentPlans[0].serviceChargePercentage}%) is &pound;{renewal.paymentPlans[0].serviceCharge}</p>
                    <p><b>Total premium is &pound;{parseFloat(renewal.premiumInCapr.toString()).toFixed(2)}</b></p>
                </div>

                <p className="payment-disclaimer">All prices are inclusive of Insurance Tax (IPT) at the appropriate rate. Premiums may include introductory discounts that may not be available at renewal.</p>

                    <div className="direct-debit-container">
                    <div className="left-section">
                        <p>Account holder</p>
                        <input
                            type="text"
                            value={accountHolder}
                            id={"valen_account_holder"}
                            onChange={(e) => updateAccountHolder(e)}
                            onBlur={() => validateAccountHolder()}
                            className={accountHolderClasses}
                        />
                        {!accountHolderValid &&
                            <div className="validation-message"><FontAwesomeIcon icon={faCircleExclamation} /> Please provide the account holders name</div>
                        }


                        <br />
                        <p>Bank name</p>
                        <select
                            value={bankName}
                            id={"valen_name_of_bank"}
                            className={bankNameClasses}
                            onChange={(e) => updateBank(e)}
                            onBlur={() => validateBankName()}>
                            {banks.map((item: { value: string; text: string }) => (
                                <option key={item.value} value={item.value}>{item.text}</option>
                            ))}
                        </select>

                        {!bankNameValid &&
                            <div className="validation-message"><FontAwesomeIcon icon={faCircleExclamation} /> Please select a bank</div>
                        }

                        <br />
                        <p>Account number</p>
                        <input
                            type="text"
                            value={accountNumber}
                            id={"valen_account_number"}
                            onChange={(e) => updateAccountNumber(e)}
                            maxLength={8}
                            onBlur={() => validateAccountNumber()}
                            className={accountNumberClasses}
                        />

                        {!accountNumberValid &&
                            <div className="validation-message"><FontAwesomeIcon icon={faCircleExclamation} /> Please enter a valid account number</div>
                        }

                        <br />
                        <p>Sort code</p>
                        <input
                            type="text"
                            value={sortCode}
                            placeholder="00-00-00"
                            id={"valen_sort-code"}
                            onChange={(e) => updateSortCode(e)}
                            onBlur={() => validateSortCode()}
                            maxLength={8}
                            className={sortCodeClasses}
                        />
                        {!sortCodeValid &&
                            <div className="validation-message"><FontAwesomeIcon icon={faCircleExclamation} /> Please enter a valid sort code</div>
                        }
                        <div className="payment-documents">
                            <InstalmentPlanStatement />
                            <CreditDebtGuarantee />
                        </div>
                    </div>
                    <div className="right-section">
                        <img className="direct-debit-logo" src={require('../assets/payment/direct-debit.png')} alt="ssl-certificate" />
                        <div className="commission-msg"><p className="highlighted-text">URGENT INFORMATION:</p> Close Brothers Premium Finance will send you an email regarding your direct debit. You will need to <span className="highlighted-text">click a link</span> which will confirm the amount of commission received and that you consent before they can progress with your application.
                            Failure to complete this process will mean that you will need to find <span className="highlighted-text">ANOTHER WAY TO PAY</span> for your policy or your policy <span className="highlighted-text">WILL BE CANCELLED</span></div>
                    </div>
                    </div>
                
                <div className="payment-address">
                    <p><b>We'll send your documents to</b></p>
                    <p>{customerDetails.email}</p>
                    {/*<p className="payment-edit">Edit this address</p>*/}
                </div>

                <div className="payment-contact">
                    <p><b>We'll contact you using these details</b></p>
                    <p>Contact number: {customerDetails.homeTelephoneNumber}</p>
                    <p>Email address: {customerDetails.email}</p>
                    {/* <p className="payment-edit">Edit contact details</p>*/}
                </div>

                <div className="payment-renewal">
                    <p><b>We'd like to keep your business covered</b></p>
                    <p>We want to make sure you and your business are always protected with essential cover. This means, with your permission we will automatically renew your insurance policy so that cover is maintained and you don't have to worry about contacting us at renew. You have the right change your mind at anytime. <span className="how-it-works-toggle" onClick={() => toggleHowItWorksDisplay()}>How it works...</span></p>
                    {displayHowItWorks &&
                        <div>
                            <ul className="renewal-ul">
                                <li>We will send you a renewal invitation which will include the quoted premium before we take any payment.</li>
                                <li>If you have paid for your original policy by Debit or Credit Card we'll securely store your payment details and automatically renew your policy in 12 months.</li>
                                <li>If things have changed and you need an updated quote, give us a call and we will make the changes for you.</li>
                                <li>If you would prefer not to take advantage of this service please untick the box. You are entitled to change your mind at any time, just give us a call on {config.phoneNumber} and we will update our records.</li>
                            </ul>
                        </div>}
                    <label className="switch">
                        <input type="checkbox" checked={autoRenew} onChange={() => toggleAutoRenew()}></input>
                        <span className="slider round"></span>
                    </label><span className="auto-renew-title">Auto-renew insurance</span>
                </div>

                <div className="payment-confirmation">
                    <p><b>Confirmation</b></p>
                    <p>By completing this order you agree with our <span><a type="button"
                        className="btn-terms-conditions"
                        href={`https://www.${config.baseLinkUrl}/terms-and-conditions/`}
                        target="_blank"
                        rel="noreferrer">
                        Terms and Conditions.
                    </a>
                    </span>This agreement will be protected by the Direct Debit Guarantee. You will be transfered to our payment provider to take payment.</p>
                </div>

                <button className="btn primary" onClick={() => confirmPay()}>Confirm and Pay</button>

                <div className="ssl-certificate">
                    <img className="ssl-certificate-logo" src={require('../assets/payment/positive-ssl.png')} alt="ssl-certificate" />
                    <p>SSL Certificates ensure safe online transactions for your business, protecting our customers from internet security threats.</p>
                </div>
            </div>
            <BackToTop />
        </>
    )
}